import { Box, Stack, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react'
import StreamLinks from './StreamLinks';
import * as helpers from '../../../utils/helpers'
const Countdown = ({ artist, track, date }) => {
    const [count, setCount] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 })
    const [targetDate, setTargetDate] = useState(new Date(track?.release_date))
    const dt = new Date();
    const status = targetDate?.getTime() - dt.getTime()
    const [isComplete, setIsComplete] = useState(status >= 0 ? false : true)

    const artistLinks = {
        apple: 'https://music.apple.com/us/artist/rex-entropy/1814986086',
        spotify: 'https://open.spotify.com/album/6hRZBNHJdHcLPAPIDZuX1M?si=GBqwzP4bRXSBGW5c3FZseQ',
        pandora: 'https://www.pandora.com/artist/rex-entropy/baseline/AL4hXn5JJVnx9rX',
        youtube: 'https://www.youtube.com/watch?v=03AIimlUfvU&list=OLAK5uy_kIXxal68IAobf28oZdgMpUwbzfzk9aqzI&pp=0gcJCWMEOCosWNin',
        // tidal: 'https://tidal.com/album/436549805',
        amazon: 'https://music.amazon.com/albums/B0F9146KCQ',
        deezer: 'https://dzr.page.link/cf7bD8p6Hm6fhqyA7'
    }
    // console.log('[Countdown] artist:', artist)
    // console.log('[Countdown] track:', track)
    // console.log('[Countdown] track---2---:', track)
    // console.log('[Countdown] date:', date)
    function countdown(dt) {
        try {

            setTargetDate(new Date(track?.release_date))
            if (targetDate) {
                // let relDate = new Date(track?.release_date)
                // const targetDate = new Date(); //!Test
                const now = new Date();
                const timeLeft = targetDate?.getTime() - now.getTime();
                console.log('[Countdown] targetDate:', targetDate)

                if (timeLeft <= 0) {
                    // return "Countdown finished!";
                    setIsComplete(true)
                    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
                }

                const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                // return `Time left: ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
                return { days, hours, minutes, seconds };
            }
        } catch (err) { console.log('[Countdown] Error:', err) }
    }

    function countup() {
        try {
            console.log('[Countup]')
            if (targetDate) {
                // const targetDate = new Date('2025-06-13T00:00:00Z');
                // const targetDate = new Date('2025-05-13T00:00:00Z'); //!Test

                const now = new Date();
                const timePast = now.getTime() - targetDate?.getTime();

                if (timePast <= 0) {
                    // return "Countdown finished!";
                    setIsComplete(false)
                    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
                }

                const days = Math.floor(timePast / (1000 * 60 * 60 * 24));
                const hours = Math.floor((timePast % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timePast % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timePast % (1000 * 60)) / 1000);

                // return `Time left: ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
                return { days, hours, minutes, seconds };
            }
        } catch (err) { console.log('[Countup] Error:', err) }
    }
    // Update the countdown every second
    useEffect(() => {
        let curCount
        setInterval(() => {
            if (!isComplete) {

                curCount = countdown(date)
                setCount(curCount)
            } else {
                // curCount = countup()
                // setCount(curCount)
                setCount({ days: 0, hours: 0, minutes: 0, seconds: 0 })
            }
            // console.log(curCount);
        }, 1000);
    }, [])

    useEffect(() => {

    }, [isComplete])

    useEffect(() => {

        setTargetDate(new Date(track?.release_date))
    }, [])

    useEffect(() => {
        // if (track?.release_date !== date) {
        setTargetDate(new Date(track?.release_date))

        // }
    }, [artist, track, date, count])

    useEffect(() => {
    }, [targetDate, count, date])


    return (
        <Stack sx={{ alignItems: 'center', cursor: !isComplete ? 'pointer' : '' }}

            onClick={() => {
                if (!isComplete) {
                    if (track?.name === 'Standing Glory') {

                        window.open(track?.pre_link, '_blank')
                    } else {

                        window.open('https://distrokid.com/hyperfollow/rexentropy/baseline', '_blank')
                    }
                }
            }}>
            <Box
                sx={{
                    width: '100%',
                    backgroundColor: 'grey',
                    height: '1rem', textAlign: 'center',
                    color: 'rgba( 255, 255, 255, 0.7)',
                    alignItems: 'center',
                    alignContent: 'center',
                    fontWeight: 'bold',
                    borderRadius: '5px 5px 0px 0px',
                    padding: '0.125rem 0.5rem',
                    fontSize: '0.65rem', fontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace"
                }}>
                {!isComplete ? `Release Date: ${helpers.simpleDateFormat(date)}`
                    // {!isComplete ? 'Release Date: Fri 6/13/25' 
                    : <p className={isComplete ? 'blink' : ''}>
                        Out Now!
                    </p>
                }
            </Box>
            <Box sx={{
                justifyContent: 'center', display: 'flex',
                gap: '0.5rem,', color: '#00FF00', textAlign: 'center',
                marginTop: '0.5rem',
                fontSize: '1.5rem',
                fontFamily: "LCD2,sans-serif",
            }}>
                <Stack sx={{ gap: '0.5rem', textAlign: 'center', }}>
                    <Box sx={{ fontSize: '0.5rem', color: '#FF00FF', }}>Days</Box>
                    <p className="blink-3">

                        {count?.days < 100 ? '0' : ''}{count?.days < 10 ? '0' : ''}{count?.days}
                    </p>
                </Stack>
                <Typography className="blink" sx={{ fontSize: '1rem', marginTop: '1rem' }}><b>:</b></Typography>
                <Stack sx={{ justifyContent: 'center', gap: '0.5rem', textAlign: 'center', }}>
                    <Box sx={{ fontSize: '0.5rem', color: '#FF00FF', }}>Hours</Box>
                    <p className="blink-3">

                        {count?.hours < 10 ? '0' : ''}{count?.hours}
                    </p>
                </Stack>
                <Typography className="blink" sx={{ fontSize: '1rem', marginTop: '1rem' }}><b>:</b></Typography>
                <Stack sx={{ justifyContent: 'center', gap: '0.5rem', textAlign: 'center', }}>
                    <Box sx={{ fontSize: '0.5rem', color: '#FF00FF', }}>Mins</Box>
                    <p className="blink-3">

                        {count?.minutes < 10 ? '0' : ''}{count?.minutes}
                    </p>
                </Stack>
                <Typography className="blink" sx={{ fontSize: '1rem', marginTop: '1rem' }}><b>:</b></Typography>
                <Stack sx={{ justifyContent: 'center', gap: '0.5rem', textAlign: 'center', }}>
                    <Box sx={{ fontSize: '0.5rem', color: '#FF00FF', }}>Secs</Box>
                    <p className="blink-3">

                        {count?.seconds < 10 ? '0' : ''}{count?.seconds}
                    </p>
                </Stack>

            </Box>
            <Box

                sx={{
                    // width: '100%',
                    marginTop: '0.5rem',
                    padding: '0.5rem',
                    textAlign: 'center',
                    borderTop: '1px solid #00FF00',
                    alignItems: 'center',
                    fontSize: '0.7rem',
                    fontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New',monospace",
                    color: '#FF00FF',
                    fontWeight: 'bold'
                }}>
                {!isComplete ? <p className="blink">
                    !CLICK TO PRE-SAVE!
                </p> :
                    <Box //sx={{ width: '90%', padding: '0.25rem' }}
                    >
                        {/* <StreamLinks artistLinks={artist?.streaming} /> */}
                        <StreamLinks artistLinks={track?.streaming ? track?.streaming : artistLinks} view="counter" />
                    </Box>
                }
            </Box>
        </Stack>
    )
}

export default Countdown